export default __webpack_public_path__ + "static/media/Zing 3.0.341e5704.gif";